import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Pricing from './pages/Pricing';
import Auth from './pages/Auth';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Study from './pages/Study';
import Legend from './pages/Legend';
import Profile from './pages/Profile';
import PaymentSuccess from './pages/PaymentSuccess';
import Admin from './pages/Admin';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Diagnostic from './pages/Diagnostic';
import ThankYou from './pages/ThankYou';
import FreeTrial from './pages/FreeTrial';
import AvatarTrial from './pages/AvatarTrial';
import OfferQuiz from './pages/OfferQuiz';
import EssaiGratuit from './pages/EssaiGratuit';
import PromoSignup from './pages/PromoSignup';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/essai-gratuit" element={<EssaiGratuit />} />
          <Route path="/promo" element={<PromoSignup />} />
          <Route path="/avatar-trial" element={<AvatarTrial />} />
          <Route path="/avatar-trial/result/:sessionId" element={<AvatarTrial />} />
          <Route path="/offre-irresistible" element={<OfferQuiz />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/study/:studyId" element={<Study />} />
          <Route path="/study/:studyId/legend" element={<Legend />} />
          <Route path="/legend" element={<Legend />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;